import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TNKAuthLoanSliderComponent } from './auth-loan-slider.component';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { TNKTransformObjectFormModule } from '../../utils/transform-object-form/transform-object-form.module';
import { MatSliderModule } from '@angular/material';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
export class TNKAuthLoanSliderModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    TNKUtilitiesModule,
    HttpClientModule,
    RouterModule,
    TNKTransformObjectFormModule,
  ],
  declarations: [TNKAuthLoanSliderComponent],
  providers: [ApiConstant],
  exports: [TNKAuthLoanSliderComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKAuthLoanSliderModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthLoanSliderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthLoanSliderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
